import ArrowIcon from '@mui/icons-material/ChevronRight'
import SwitchAccountIcon from '@mui/icons-material/SwapHoriz'
import { Box, Dialog, DialogTitle, ListItemText, MenuItem, MenuList, Select } from '@mui/material'
import { useTranslate } from 'ra-core'
import React, { useState } from 'react'
import { MenuItemLink } from 'react-admin'

import { useAccounts } from '../api/accountsProvider'
import { useCommonStyles } from '../config/theme'

export const AccountSwitchMenuItemLink = (props) => {
  const { accounts, currentAccount, setCurrentAccount } = useAccounts()

  const [accountsDialogOpen, setAccountsDialogOpen] = useState(false)
  const closeDialog = () => setAccountsDialogOpen(false)
  const translate = useTranslate()

  const switchAccount = (account) => {
    if (account.id === currentAccount.id) {
      closeDialog()
      return
    }
    setCurrentAccount(account)
  }

  return currentAccount ? (
    <>
      <MenuItemLink
        {...props}
        primaryText="mymove.switchAccount"
        leftIcon={<SwitchAccountIcon />}
        onClick={() => setAccountsDialogOpen(true)}
      />
      <Dialog open={accountsDialogOpen} onClose={closeDialog}>
        <DialogTitle>{translate('mymove.selectAccount')}</DialogTitle>
        <MenuList disablePadding>
          {accounts.map((account) => {
            const { id, name } = account
            const isCurrent = id === currentAccount.id
            return (
              <MenuItem key={id} onClick={() => switchAccount(account)} selected={isCurrent}>
                <ListItemText primary={name} />
              </MenuItem>
            )
          })}
        </MenuList>
      </Dialog>
    </>
  ) : null
}

const AccountSwitch = () => {
  const commonClasses = useCommonStyles()
  const { accounts, currentAccount, setCurrentAccount } = useAccounts()
  const switchAccount = (event) => setCurrentAccount(event.target.value)

  const [isAccountSwitchExpanded, setIsAccountSwitchExpanded] = useState(false)
  const onAccountSwitchOpen = () => setIsAccountSwitchExpanded(true)
  const onAccountSwitchClose = () => setIsAccountSwitchExpanded(false)

  return currentAccount ? (
    <Box component="span" sx={commonClasses.textWithLargeIcons}>
      <Select
        value={currentAccount}
        onOpen={onAccountSwitchOpen}
        onClose={onAccountSwitchClose}
        onChange={switchAccount}
        sx={{
          ...commonClasses.commonSwitchRoot,
          ...(isAccountSwitchExpanded ? commonClasses.commonSwitchExpandedBorder : {}),
          '& .MuiSelect-icon': commonClasses.commonSwitchIcon,
        }}
      >
        {accounts.map((account) => {
          const { id, name } = account
          return (
            <MenuItem key={id} value={account}>
              {name}
            </MenuItem>
          )
        })}
      </Select>
      <ArrowIcon />
    </Box>
  ) : null
}

export default AccountSwitch
